<template>
    <v-sheet>
        <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">
            개인기본정보
            <!-- <span v-if="mode == 'form'" class="page-text--sm grey-6--text pl-8 font-weight-regular">경력 작성시 더 좋은 일자리를 구할 수 있습니다.</span> -->
        </h5>

        <v-row>
            <v-col cols="12" sm="auto" v-if="mode != 'form'">
                <v-img :aspect-ratio="125 / 170" width="125" :src="profileSrc" class="mx-auto rounded">
                    <v-fade-transition>
                        <v-overlay v-show="!profileSrc" absolute>
                            <v-icon>mdi-image</v-icon>
                        </v-overlay>
                    </v-fade-transition>
                </v-img>
            </v-col>
            <v-col cols="12" sm="">
                <vertical-form-table v-model="resume" v-bind="{ mode, items }" @input="emit">
                    <template slot="연락처">
                        <template v-if="mode == 'form'">
                            <user-contact-certification v-model="resume.personalInformation.phone" outlined dense :btnAttrs="{ color: 'grey-6 white--text', className: 'w-80px w-lg-100px mt-n8' }" />
                        </template>
                        <template v-else>
                            <p class="page-text grey--text">{{ resume?.personalInformation?.phone?.phoneNumberFormat?.() }}</p>
                        </template>
                    </template>
                </vertical-form-table>
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
import { attrs_input, GENDERS, initResume } from "@/assets/variables";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import UserContactCertification from "@/components/dumb/user-contact-certification.vue";

export default {
    components: {
        VerticalFormTable,
        UserContactCertification,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // resume
        mode: { type: String, default: "form" },
    },
    data: () => ({
        resume: initResume(),
    }),
    computed: {
        residence() {
            let { postcode, address1, address2 } = this.resume?.personalInformation?.residence || {};

            let residence = "";
            if (postcode) residence += `[${postcode}] `;
            if (address1) residence += `${address1} `;
            if (address2) residence += `${address2} `;
            return residence.trim();
        },
        profileSrc() {
            if (this.resume?.profile?.url) return this.resume.profile.url;
            if (this.resume?.profile instanceof File) return URL.createObjectURL(this.resume.profile);
            return null;
        },
        items() {
            let items = [
                {
                    key: "personalInformation.name",
                    term: "이름",
                    type: "text",
                    required: true,
                },
                {
                    key: "personalInformation.bornAt",
                    term: "생년월일",
                    type: "date",
                    required: true,
                },
                {
                    key: "personalInformation.gender",
                    term: "성별",
                    type: "select",
                    data: GENDERS[this.resume?.personalInformation?.gender]?.text,
                    required: true,
                    class: "resume-personal-information-gender",
                    menuProps: { attach: ".resume-personal-information-gender" },
                    items: Object.values(GENDERS),
                },
                {
                    term: "연락처",
                    required: true,
                },
                {
                    key: "personalInformation.email",
                    term: "이메일",
                    type: "email",
                    required: true,
                },
                {
                    key: "personalInformation.residence",
                    term: "주소",
                    type: "address",
                    data: this.residence,
                    required: true,
                },
            ];
            if (this.mode == "form") {
                items.push({
                    key: "profile",
                    term: "프로필 사진 업로드",
                    type: "file",
                    accept: "image/*",
                });
            }
            return items.map((item) => {
                if (this.mode == "form") {
                    delete item.data;
                }
                return { ...attrs_input, ...item };
            });
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.resume = { ...initResume(), ...this.value };
        },
        emit() {
            let { profile, personalInformation } = this.resume;
            this.$emit("input", { ...this.value, profile, personalInformation });
        },
    },
};
</script>
